var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Environment_1 = __importDefault(require("@hendersonengineers/types/Environment"));
const isDevelopment_1 = require("../isDevelopment");
const isStage_1 = require("../isStage");
const isProduction_1 = require("../isProduction");
function convertUrl(url, targetEnv) {
    const prodUrl = url
        .replace(isDevelopment_1.DEVELOPMENT_PATTERN, 'hendersonengineers.com')
        .replace(isStage_1.STAGE_PATTERN, 'hendersonengineers.com'); //always convert dev/stage urls to prod first to make sure we don't double convert below
    switch (targetEnv) {
        case Environment_1.default.Development:
            return prodUrl
                .replace(isProduction_1.OLD_PRODUCTION_PATTERN, 'dev.hendersonengineers.com')
                .replace(isProduction_1.PRODUCTION_PATTERN, 'dev.hendersonengineers.com');
        case Environment_1.default.Stage:
            return prodUrl
                .replace(isProduction_1.OLD_PRODUCTION_PATTERN, 'stage.hendersonengineers.com')
                .replace(isProduction_1.PRODUCTION_PATTERN, 'stage.hendersonengineers.com');
        case Environment_1.default.Production:
            return prodUrl;
    }
    return url;
}
exports.default = convertUrl;
//# sourceMappingURL=convertUrl.js.map